export default class AsForm {
    public examId: number = 0
    public qId: string = ''
    public userExamId: number = 0
    public answers: string[] = []
}